<mat-dialog-content>
    <mat-card-title>Delete Category: {{dialogTitle | titlecase}}</mat-card-title>
    <mat-card-subtitle>With Questions:</mat-card-subtitle>
    <mat-chip-list>
        <mat-chip *ngFor="let question of text" matTooltip="{{question.answer}}">{{question.question}}</mat-chip>
    </mat-chip-list>
</mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions right">
    <button [mat-dialog-close]="true" class="spaced_button" color="primary" id="categoryDelYes" mat-raised-button>Yes</button>
    <button [mat-dialog-close]="false" mat-raised-button color="primary" id="categoryDelNo">No</button>
</mat-dialog-actions>
